import { RestSlice } from './rest.slice';
import { CustomFieldDefinition } from '@rcp/types';

export const customFieldSlice = new RestSlice<CustomFieldDefinition>('custom-field', 'Settings/CustomFieldDefinitions');
export default customFieldSlice.rests.reducer;
